import {
  Button,
  Dialog,
  DialogActions,
  DialogBody,
  DialogContent,
  DialogSurface,
  DialogTitle,
  DialogTrigger,
} from "@fluentui/react-components";
import { WarningIcon } from "@fluentui/react-icons-mdl2";

import { RemoveButton } from "components/styled";
import { useAppTheme } from "hooks/useAppTheme";

type Props = {
  isOpen: boolean;
  title: string;
  description: string;
  dismissLabel?: string;
  confirmLabel?: string;
  isDisabled?: boolean;
  onConfirm: () => void;
  toggleOpen: () => void;
};

export const ConfirmationDialog = ({
  title,
  description,
  isOpen,
  dismissLabel,
  onConfirm,
  confirmLabel,
  isDisabled = false,
  toggleOpen,
}: Props) => {
  const theme = useAppTheme();
  return (
    <Dialog modalType="alert" open={isOpen}>
      <DialogSurface>
        <DialogBody>
          <DialogTitle
            style={{
              display: "flex",
              alignItems: "center",
              color: theme.palette.redDark,
              gap: "5px",
            }}
          >
            <WarningIcon />
            {title}
          </DialogTitle>
          <DialogContent>{description}</DialogContent>
          <DialogActions
            style={{
              display: "flex",
              flexDirection: "row",
              justifyContent: "flex-end",
            }}
          >
            <DialogTrigger disableButtonEnhancement>
              <Button appearance="secondary" onClick={toggleOpen}>
                {dismissLabel || "Close"}
              </Button>
            </DialogTrigger>
            <RemoveButton onClick={onConfirm} disabled={isDisabled}>
              {confirmLabel || "Confirm"}
            </RemoveButton>
          </DialogActions>
        </DialogBody>
      </DialogSurface>
    </Dialog>
  );
};
